import {Vue, Ncs} from '../search/index'
import App from '../search/Form.vue'

document.addEventListener('DOMContentLoaded', () => {
  const main = document.getElementById('main')
  const el = main.appendChild(document.createElement('div'))
  new Vue({i18n: Ncs.i18n, el, store: Ncs.store, render: h => h(App)})
})
